import { API_BASE,axiosApi } from "../config"
import { CreateRunReturnInterface, GeneralReturnInterface, GetRunSettingsReturnInterface, GetRunsParamType, GetRunsReturnInterface, RunStatusType } from "../types"



export const createRun = async (body:{plateIds:number[],type?:string}): Promise<CreateRunReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/createrun`,body)).data
}

export async function previewRunId(body:{plateIds:number[]}): Promise<{code:number, message:string, runId?:number}> {
     return (await axiosApi.post(`${API_BASE}/previewRunId`,body)).data
}

export async function getRuns(body: {
    type?: GetRunsParamType
    runId?: number
    page?: number
    pageSize?: number
    hideDeadFlowCells?: boolean
    showOnlyDeadFlowCells?: boolean
    showOnlyMostRecentFlowCellUse?: boolean
    flowCellFilter?: string
} = { type: 'all' }): Promise<GetRunsReturnInterface> {
     return (await axiosApi.post(`${API_BASE}/getRuns`, body)).data
}


export async function updateRun(body:{status?:RunStatusType,type?:string,device?:string,flowCellId?:string,pores?:number,duration?:number,used?:boolean,notes?:string,mux_scan_results?:string,channel_states?:string, runId:number}): Promise<GeneralReturnInterface> {
     return (await axiosApi.post(`${API_BASE}/updateRun`,body)).data
}



export async function regenerateRunSettings(body:{runId:number}): Promise<GetRunSettingsReturnInterface> {
     return (await axiosApi.post(`${API_BASE}/regenerateRunSettings`,body)).data
}

export async function regenerateAllRunSettings(): Promise<GeneralReturnInterface> {
     return (await axiosApi.post(`${API_BASE}/regenerateAllRunSettings`,{})).data
}

export async function getRunSettings(body:{runId:number}): Promise<GetRunSettingsReturnInterface> {
     return (await axiosApi.post(`${API_BASE}/getRunSettings`,body)).data
}

export async function getRunReports(body:{runId:number}): Promise<{code:number, reports?:string[], message?:string}> {
     return (await axiosApi.post(`${API_BASE}/getRunReports`,body)).data
}
export async function getNextflowRunStatus(body:{runId:number}): Promise<{code:number, status:string, message:string}> {
     return (await axiosApi.post(`${API_BASE}/getNextflowRunStatus`,body)).data
}

export async function checkSkipReportStatus(body:{runId:number}): Promise<{code:number, exists?:boolean, message?:string}> {
     return (await axiosApi.get(`${API_BASE}/check-skip-report-status/${body.runId}`)).data
}

export async function setSkipReportCheck(body:{runId:number}): Promise<{code:number, message?:string, runId?:number}> {
     return (await axiosApi.post(`${API_BASE}/set-skip-report-check/${body.runId}`)).data
}

export async function deleteSkipReportCheck(body:{runId:number}): Promise<{code:number, message?:string, runId?:number}> {
     return (await axiosApi.delete(`${API_BASE}/delete-skip-report-check/${body.runId}`)).data
}

export async function resetRunningLog(body:{runId:number, password:string}): Promise<{code:number, message:string, runId?:number}> {
     return (await axiosApi.post(`${API_BASE}/resetRunningLog`,body)).data
}

export async function getNextflowRunStatuses(body:{runIds:number[]}): Promise<{code:number, statuses?:{runId:number, status:string}[], message?:string}> {
     try {
          // Add a flag to suppress global error handling for this request
          const response = await axiosApi.post(`${API_BASE}/getNextflowRunStatuses`, body, {
               // This metadata can be checked in the interceptor to suppress error messages
               metadata: { suppressError: true }
          } as any)
          return response.data
     } catch (error: any) {
          // Silently handle the error and return a friendly response
          // Don't log error to console since interceptor already logged it
          return {
               code: 503,
               statuses: body.runIds.map(runId => ({ runId, status: 'not running' })),
               message: 'GPU analysis server is currently unavailable. Run statuses cannot be retrieved at this time.'
          }
     }
}
export async function getGpuServers(): Promise<{code:number, servers?:{name:string, url:string}[], message?:string}> {
     return (await axiosApi.post(`${API_BASE}/getGpuServers`,{})).data
}

export async function pingGpuServers(): Promise<{code:number, servers?:{name:string, url:string, status:string, serverStatus?:string, timestamp?:string, cpuUsage?:number, cpuCores?:number, memoryUsage?:any, gpuUsage?:any, folders?:any[], message?:string}[], message?:string}> {
     return (await axiosApi.post(`${API_BASE}/pingGpuServers`,{})).data
}

export async function getGpuRunDetails(body:{serverUrl:string, runId:string}): Promise<{code:number, details?:any, message?:string}> {
     return (await axiosApi.post(`${API_BASE}/getGpuRunDetails`,body)).data
}

export async function getGpuSmi(body:{serverUrl:string}): Promise<{code:number, output?:string, timestamp?:string, message?:string}> {
     return (await axiosApi.post(`${API_BASE}/getGpuSmi`,body)).data
}

export async function runGpuAnalysis(body:{serverUrl:string, runId:string}): Promise<{code:number, message?:string, status?:string, runId?:string}> {
     return (await axiosApi.post(`${API_BASE}/runGpuAnalysis`,body)).data
}

export async function getNextflowLog(body:{serverUrl:string, runId:string}): Promise<{code:number, log?:string, message?:string}> {
     return (await axiosApi.post(`${API_BASE}/getNextflowLog`,body)).data
}

export async function queueAnalysis(body:{runIds:number[]}): Promise<{code:number, message?:string, runIds?:number[]}> {
     return (await axiosApi.post(`${API_BASE}/queueAnalysis`,body)).data
}

export async function makePeek(body:{runId:number}): Promise<{code:number, message?:string, runId?:number, status?:string}> {
     return (await axiosApi.post(`${API_BASE}/makePeek`,body)).data
}

export async function showPeekResult(body:{runId:number}): Promise<{code:number, message?:string, runId?:string, orders?:{orderId:string, files:{resultHtml:string|null, zip:string|null, errorLog:string|null}}[], total_reads_in_bam?:number|null}> {
     return (await axiosApi.post(`${API_BASE}/showPeekResult`,body)).data
}

export async function showPeekErrorLog(body:{runId:number}): Promise<{code:number, runId?:string, exists?:boolean, size?:{bytes:number, mb:string}, lastModified?:string, message?:string}> {
     return (await axiosApi.get(`${API_BASE}/show-peek-error/${body.runId}`)).data
}

export async function getReportMuxScansFromReport(body:{runId:number}): Promise<{code:number, message?:string, data?:{mux_scan_results?:any[]}}> {
     return (await axiosApi.post(`${API_BASE}/getReportMuxScansFromReport`, body)).data
}

export async function checkRunErrorLog(body:{runId:number}): Promise<{code:number, message?:string}> {
     return (await axiosApi.get(`${API_BASE}/check-run-error-log/${body.runId}`)).data
}

export async function checkNextflowLog(body:{runId:number}): Promise<{code:number, message?:string}> {
     return (await axiosApi.get(`${API_BASE}/check-nextflow-log/${body.runId}`)).data
}

export async function getBasecallerOutputLogs(body:{runId:number}): Promise<{code:number, files?:string[], message?:string}> {
     return (await axiosApi.get(`${API_BASE}/show-basecaller-output-log/${body.runId}`)).data
}

export async function deleteEmptyBasecallerLogs(body:{runId:number}): Promise<{code:number, message?:string}> {
     return (await axiosApi.delete(`${API_BASE}/delete-empty-basecaller-logs/${body.runId}`)).data
}

export async function cleanRunFolder(body:{runId:number}): Promise<{code:number, message?:string, details?:any}> {
     return (await axiosApi.post(`${API_BASE}/cleanRunFolder`, body)).data
}

export async function cleanAllRunFolders(): Promise<{code:number, message?:string, total?:number, cleaned?:number[], skipped?:number[], failed?:{runId:number, message:string}[]}> {
     return (await axiosApi.post(`${API_BASE}/cleanAllRunFolders`, {})).data
}
